const processSteps = (
  cmsProgressStepContainer,
  completed,
  cmsProgressBarContainer,
  step = 'stepZero',
  parentContainerElem = null,
) => {
  const steps = {
    stepZero: {
      style: { width: '10%', backgroundColor: '#f63a0f', color: '#fff' },
      text: 'Start',
      klass: '.cms--progress--step-0',
    },
    stepOne: {
      style: { width: '30%', backgroundColor: '#f27011', color: '#fff' },
      text: 'Step 1',
      klass: '.cms--progress--step-1',
    },
    stepTwo: {
      style: { width: '65%', backgroundColor: '#f2b01e', color: '#fff' },
      text: 'Step 2',
      klass: '.cms--progress--step-2',
    },
    stepThree: {
      style: { width: '100%', backgroundColor: '#86e01e', color: '#2c3a53' },
      text: 'Completed!',
      klass: '.cms--progress--step-3',
    },
  };

  const cmsProgressBar = cmsProgressBarContainer.querySelector('.progress-bar');

  if (completed) {
    const cmsProgressStep = parentContainerElem
      ? parentContainerElem.querySelector(steps[step].klass)
      : cmsProgressStepContainer.querySelector(steps[step].klass);
    if (cmsProgressStep) {
      const cmsProgressStepIcon = cmsProgressStep.querySelector('i');
      cmsProgressStep.classList.remove('badge-default');
      cmsProgressStep.classList.add('badge-success');
      cmsProgressStepIcon.classList.remove('webconnect');
      cmsProgressStepIcon.classList.add('webconnect-check');
    }
    Object.keys(steps[step].style).forEach(styleProp => {
      cmsProgressBar.style[styleProp.toString()] = steps[step].style[styleProp.toString()];
    });
    cmsProgressBar.innerText = steps[step].text;
  } else {
    if (step === 'stepZero') {
      Object.keys(steps).forEach(stp => {
        const cmsProgressStep = parentContainerElem
          ? parentContainerElem.querySelector(steps[step].klass)
          : cmsProgressStepContainer.querySelector(steps[step].klass);
        if (cmsProgressStep) {
          const cmsProgressStepIcon = cmsProgressStep.querySelector('i');
          cmsProgressStep.classList.remove('badge-success');
          cmsProgressStep.classList.add('badge-default');
          cmsProgressStepIcon.classList.remove('webconnect-check');
          cmsProgressStepIcon.classList.add('webconnect');
        }
      });
      Object.keys(steps[step].style).forEach(styleProp => {
        cmsProgressBar.style[styleProp.toString()] = steps[step].style[styleProp.toString()];
      });
      cmsProgressBar.innerText = steps[step].text;
    } else {
      const cmsProgressStep = parentContainerElem
        ? parentContainerElem.querySelector(steps[step].klass)
        : cmsProgressStepContainer.querySelector(steps[step].klass);
      if (cmsProgressStep) {
        const cmsProgressStepIcon = cmsProgressStep.querySelector('i');
        cmsProgressStep.classList.remove('badge-success');
        cmsProgressStep.classList.add('badge-default');
        cmsProgressStepIcon.classList.remove('webconnect-check');
        cmsProgressStepIcon.classList.add('webconnect');
        Object.keys(steps[step].style).forEach(styleProp => {
          cmsProgressBar.style[styleProp.toString()] = steps[step].style[styleProp.toString()];
        });
        cmsProgressBar.innerText = steps[step].text;
      }
    }
  }
};

const convertToTitleCase = (stringToConvert, splitBy = '-', joinBy = ' ') => {
  let convertedString = stringToConvert
    .toLowerCase()
    .split(splitBy)
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(joinBy);
  return convertedString;
};

export { processSteps, convertToTitleCase };
